import React from 'react';

const BookCategories = () => (
  <h1 className="Cat">Under construction</h1>
);

export default BookCategories;
